import React from 'react';
import { ProductLinePanierView } from './ProductLinePanier.view';
import { sanitizeCalculToString } from '../../../../helpers/number/sanitizeCalul';
import { CommandeLinePanier } from '../../../../types/commandeLine/commandeLine.def';

interface ProductLinePanierProps {
  line: CommandeLinePanier;
  onClickViewMore: () => void;
  onClickTrash: () => void;
  hideButtons?: boolean;
  editableQuantity?: boolean;
  defaultQuantity?: string | number;
  onChangeQuantity?: (e: any) => void;
}

export const ProductLinePanier = ({
  line,
  onClickViewMore,
  onClickTrash,
  hideButtons = false,
  editableQuantity,
  defaultQuantity,
  onChangeQuantity
}: ProductLinePanierProps) => {
  return (
    <ProductLinePanierView
      name={line.produit.name}
      reference={line.produit.ref}
      price={sanitizeCalculToString(line.totalLine)}
      quantity={line.quantite}
      onClickViewMore={onClickViewMore}
      onClickTrash={onClickTrash}
      hideButtons={hideButtons}
      editableQuantity={editableQuantity}
      defaultQuantity={defaultQuantity}
      onChangeQuantity={onChangeQuantity}
    />
  );
};
